module.exports = __webpack_public_path__ + "assets/img/hulianwang.ff78217a.png";